import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<Legal />} />
          <Route path="/datenschutz" element={<Legal />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LanguageProvider>
  );
}

export default App;
